import { render } from "./CommentImageGallery.vue?vue&type=template&id=06f0814b"
import script from "./CommentImageGallery.vue?vue&type=script&lang=js"
export * from "./CommentImageGallery.vue?vue&type=script&lang=js"

import "./CommentImageGallery.vue?vue&type=style&index=0&id=06f0814b&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__